import { useState, useEffect } from "react";

/**
 * Returns the current online status and updates when the browser
 * fires 'online' or 'offline' events.
 */
export function useOnlineStatus(): boolean {
	const [isOnline, setIsOnline] = useState(() => navigator.onLine);

	useEffect(() => {
		const handleOnline = () => setIsOnline(true);
		const handleOffline = () => setIsOnline(false);

		window.addEventListener("online", handleOnline);
		window.addEventListener("offline", handleOffline);

		return () => {
			window.removeEventListener("online", handleOnline);
			window.removeEventListener("offline", handleOffline);
		};
	}, []);

	return isOnline;
}
